enum PageViewMode {
	SINGLE = "SINGLE",
	DUAL = "DUAL"
}

export default PageViewMode;